import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useForm, useWatch, Controller } from 'react-hook-form'
import { Encabezado } from '../../../Components/Encabezado/Encabezado'
import Loading from '../../../Components/Modals/Loading/Loader';
import { FaFilePdf } from "react-icons/fa6";
import { FaFileWord } from "react-icons/fa";

import { 
    Paper, 
    Stack, 
    Typography 
} from '@mui/material';

import Select from "react-select";

import { 
    selectAllEmpleadosList,
    fetchAllEmpleados,
    fetchCambiarSuccess,
    fetchGetReporteCertificacionLaboral,
    selectMessage,
    selectIsLoading,
    selectIsSuccess
} from '../../../redux/Empleados/EmpleadosSlice';

import swal from 'sweetalert';
import { formatDocument } from '../../../utils/enums/formatDocument';

export const CertificacionLaboral = () => {

    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    // ? HOOK-STATE
    const [listaEmpleadosState, setListaEmpleadosState] = useState([]);

    // ? HOOK-SELECTOR
    const empleadosList = useSelector(selectAllEmpleadosList);
    const message = useSelector(selectMessage);
    const isLoading = useSelector(selectIsLoading);
    const isSuccess = useSelector(selectIsSuccess);

    const refreshSuccess = () => dispatch(fetchCambiarSuccess());

    // ? HOOK-FORM
    const { 
        register,
        control,
        setValue
    } = useForm({
        defaultValues: {
            empleado: {
                id: 0
            }
        }
    })

    // ? HOOK-WATCH
    const empleado = useWatch({
        control,
        name: 'empleado'
    })

    // ? HOOK-EFFECT
    useEffect(() => {
        dispatch(fetchAllEmpleados());
    }, [])

    useEffect(() => {
        setListaEmpleadosState([
            { id: 0, nombreLabel: "Seleccionar Empleado" },
            ...empleadosList,
        ]);
    
    }, [empleadosList])

    // ? HOOK-EFFECT PARA LAS ALERTAS
    useEffect(() => {
      
        if(isSuccess === 'success' && message.length > 0){
          swal({title: 'Exitoso', text: message, icon: 'success'});
          setValue('empleado', {id: 0});
          refreshSuccess();
        }
        else if(isSuccess === 'error'){
          swal({title: 'Error', text: message, icon: 'error'});
          refreshSuccess();
        }
    
    }, [isSuccess])

    // * FUNCION PARA GENERAR EL REPORTE.
    const getReport = (format) => {
        
        if(empleado.id === 0){
            swal("Error!", "Debe seleccionar un empleado.", "error");
            return;
        }

        dispatch(fetchGetReporteCertificacionLaboral({ empleado, format }));
    }

  return (
    <Encabezado title='Certificación Laboral'>
        <Stack className="form-group" width={'50%'}>
            <Paper>
                <Stack p={3}>
                    <Typography fontSize='12px' fontWeight='bold'>Empleado</Typography>

                    <Controller
                    control={control}
                    name="empleadoId"
                    {...register("empleado")}
                    render={({ field }) => (
                        <Select
                        id='select-empleado'
                        classNamePrefix="select"
                        isSearchable={true}
                        placeholder="Seleccionar Empleado"
                        options={listaEmpleadosState}
                        getOptionLabel={(option) => option.nombreLabel}
                        getOptionValue={(option) => option.id}
                        onChange={(e) => field.onChange(e)}
                        value={listaEmpleadosState.find(x => x.id === field.value.id)}
                        />
                    )}
                    />
                    
                    <div className='mt-4 d-flex justify-content-end'>
                        <button onClick={() => getReport(formatDocument.pdf)} className='btn btn-danger me-2'>PDF <FaFilePdf style={{marginLeft: 3, marginTop: -2}} fontSize={22} /> </button>
                        <button onClick={() => getReport(formatDocument.word)} className='btn btn-primary'>Word <FaFileWord style={{marginLeft: 3, marginTop: -2}} fontSize={22} /> </button>
                    </div>

                </Stack>
            </Paper>

        </Stack>

        <Loading open={isLoading} />
    </Encabezado>
  )
}
